import React from "react";

const MarketPriceSection: React.FC = () => {
  return (
    <div className="space-y-3">
      <h3 className="text-base font-semibold text-gray-900 font-serif">
        Marktpreis
      </h3>
      <div className="grid grid-cols-3 gap-2 filter blur-sm opacity-50 select-none pointer-events-none">
        <div className="p-3 bg-gray-50 rounded text-center relative overflow-hidden">
          <p className="text-xl font-bold text-gray-900 mb-1">
            540.000 €
            <span className="text-sm font-normal text-green-600 ml-1">
              (+5%)
            </span>
          </p>
          <p className="text-xs text-gray-600 font-sans font-medium">
            Marktpreis
          </p>
        </div>
        <div className="p-3 bg-gray-50 rounded text-center relative overflow-hidden">
          <p className="text-xl font-bold text-gray-900 mb-1">
            4.200 €
            <span className="text-sm font-normal text-green-600 ml-1">
              (+2%)
            </span>
          </p>
          <p className="text-xs text-gray-600 font-sans font-medium">
            Preis pro m²
          </p>
        </div>
        <div className="p-3 bg-gray-50 rounded text-center relative overflow-hidden">
          <p className="text-xl font-bold text-gray-900 mb-1">3 Potenziale</p>
          <p className="text-xs text-gray-600 font-sans font-medium">
            Potenziale
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketPriceSection;
